/*
 * 企業側 ホットライン 更新
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_CLIENT_HOTLINE_PAUSE = 'API_UPDATE_CLIENT_HOTLINE_PAUSE';
/**
 * クライアント：ホットライン 募集一時停止
 */
export const apiUpdateClientHotlinePause = ({ path: { id } }, meta) => apiUpdate(API_UPDATE_CLIENT_HOTLINE_PAUSE, `/client/hotline/${id}/pause`, {}, meta);
